import { format } from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import { makePostRequest } from 'owa-ows-gateway';

/**
 * Performs a request to the Places API to fetch the place
 */
export function getPlace(id: string): Promise<Response> {
    const queryTemplate: string = "Locations/odata/api/v1.0/Users('{0}')/Places/Places.GetPlace()";

    let userConfiguration = getUserConfiguration();

    // calculateEndPoint
    let endpoint = format(queryTemplate, userConfiguration.SessionSettings.UserEmailAddress);

    let request = {
        Id: id,
    };
    // make server call
    return makePostRequest(
        endpoint,
        request,
        undefined /* correlationId */,
        true /* returnFullResponse */,
        undefined /* customHeaders */,
        undefined /* throwServiceError */,
        true /* sendPayloadAsBody */
    );
}
